import { themeVars, ToastVariant } from '@tundr/theme';
import { style, styleVariants } from '@vanilla-extract/css';
import { nToPx } from '@tundr/theme';

export const disclaimerClass = style({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  justifyContent: 'center',
  gap: themeVars.space.x4,
  padding: nToPx(themeVars.space.x3, themeVars.space.x4),
  borderRadius: themeVars.radius.md,
  borderWidth: '1px',
  borderStyle: 'solid',
});

export const disclaimerVariants = styleVariants({
  [ToastVariant.INFO]: {
    color: themeVars.colors.components.toast[ToastVariant.SUCCESS].text.default,
    borderColor: themeVars.colors.components.toast[ToastVariant.INFO].border,
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.INFO].background.default,
  },
  [ToastVariant.WARNING]: {
    color: themeVars.colors.components.toast[ToastVariant.SUCCESS].text.default,
    borderColor: themeVars.colors.components.toast[ToastVariant.WARNING].border,
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.WARNING].background
        .default,
  },
  [ToastVariant.SUCCESS]: {
    color: themeVars.colors.components.toast[ToastVariant.SUCCESS].text.default,
    borderColor: themeVars.colors.components.toast[ToastVariant.SUCCESS].border,
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.SUCCESS].background
        .default,
  },
  [ToastVariant.ERROR]: {
    color: themeVars.colors.components.toast[ToastVariant.SUCCESS].text.default,
    borderColor: themeVars.colors.components.toast[ToastVariant.ERROR].border,
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.ERROR].background.default,
  },
});

export const disclaimerFullWidthClass = style({
  width: '100%',
  maxWidth: 'none',
});

export const disclaimerIconClass = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 36,
  height: 36,
  borderRadius: themeVars.radius.circle,
  padding: nToPx(4, 6, 2, 6),
});

export const disclaimerIconVariants = styleVariants({
  [ToastVariant.INFO]: {
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.INFO].background.icon,
    color: themeVars.colors.components.toast[ToastVariant.INFO].text.icon,
  },
  [ToastVariant.WARNING]: {
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.WARNING].background.icon,
    color: themeVars.colors.components.toast[ToastVariant.WARNING].text.icon,
  },
  [ToastVariant.SUCCESS]: {
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.SUCCESS].background.icon,
    color: themeVars.colors.components.toast[ToastVariant.SUCCESS].text.icon,
  },
  [ToastVariant.ERROR]: {
    backgroundColor:
      themeVars.colors.components.toast[ToastVariant.ERROR].background.icon,
    color: themeVars.colors.components.toast[ToastVariant.ERROR].text.icon,
  },
});

export const disclaimerContentClass = style({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});
export const disclaimerTitleClass = style({
  fontWeight: themeVars.font.weight.bold,
  fontSize: themeVars.font.size.textMd,
});
export const disclaimerDescriptionClass = style({
  fontSize: themeVars.font.size.textMd,
  lineHeight: 1.4,
  marginTop: themeVars.space.x2,
});
